module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "eve-of-warfare-8.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("Other Books by Sylvia Day")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('strong', [_vm._v("Contemporary Romance")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_vm._v("The Crossfire® Saga")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Bared to You")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Reflected in You")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Entwined with You")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Captivated by You")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("One with You")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_vm._v("The Jax & Gia Series")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Afterburn/Aftershock")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('strong', [_vm._v("Paranormal Romance")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_vm._v("The Renegade Angels Series")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("A Dark Kiss of Rapture")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("A Touch of Crimson")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("A Caress of Wings")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("A Hunger So Wild")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_vm._v("The Dream Guardians Series")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Pleasures of the Night")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Heat of the Night")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('strong', [_vm._v("Historical Romance")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_vm._v("The Georgian Series")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Ask for It")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Passion for the Game")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("A Passion for Him")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Don’t Tempt Me")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('strong', [_vm._v("Urban Fantasy")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_vm._v("The Marked Series")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Eve of Darkness")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Eve of Destruction")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Eve of Chaos")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Eve of Warfare")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Eve of Sin City")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('strong', [_vm._v("Single Titles")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("The Stranger I Married")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Seven Years to Sin")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Pride and Pleasure")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("In the Flesh")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_vm._v("Omnibus")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Spellbound")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Scandalous Liaisons")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Love Affairs")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('strong', [_vm._v("Novellas")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_vm._v("The Shadow Stalkers Miniseries")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Razor’s Edge")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Taking the Heat")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Blood & Roses")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("On Fire")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_vm._v("The Carnal Thirst Series")]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Misled")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Kiss of the Night")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("Butterfly in Frost")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("All Revved Up")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("“Mischief and the Marquess” in Perfect Kisses")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', [_vm._v("“Hard to Breathe” in Premiere")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85480d06","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eveofwarfarebooks.vue
// module id = 60
// module chunks = 0